import { render, staticRenderFns } from "./T1Spinner.vue?vue&type=template&id=4f5b4384&scoped=true&"
import script from "./T1Spinner.vue?vue&type=script&lang=js&"
export * from "./T1Spinner.vue?vue&type=script&lang=js&"
import style0 from "./T1Spinner.vue?vue&type=style&index=0&id=4f5b4384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b4384",
  null
  
)

export default component.exports